import { render } from "./Templates.vue?vue&type=template&id=5c752a15&scoped=true"
import script from "./Templates.vue?vue&type=script&lang=js"
export * from "./Templates.vue?vue&type=script&lang=js"

import "./Templates.vue?vue&type=style&index=0&id=5c752a15&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5c752a15"

export default script